import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter } from 'react-router-dom';
import { AuthProvider as PlatformAuthProvider } from '@platform/auth-sdk';
import { ThemeProvider } from './theme/ThemeContext.jsx';
import { AuthProvider } from './components/Auth/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { ExpiryProvider } from './context/ExpiryContext';
import { CallModeProvider } from './context/CallModeContext';
import { LiveQueueProvider } from './context/LiveQueueContext';
import SoftphoneHost from './components/Softphone/SoftphoneHost';

/**
 * Platform Auth SDK configuration.
 * Uses Vite environment variables for Identity Center connection.
 */
const authSDKConfig = {
  identityCenterUrl: import.meta.env.VITE_IDENTITY_CENTER_URL || 'https://id.digihrms.com',
  clientId: import.meta.env.VITE_AUTH_CLIENT_ID || 'crm-frontend',
  redirectUri: import.meta.env.VITE_AUTH_REDIRECT_URI || `${window.location.origin}/auth/callback`,
  audience: 'platform-services',
  scope: 'openid profile email',
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <PlatformAuthProvider config={authSDKConfig}>
      <ThemeProvider>
        <NotificationProvider> {/* ✅ Global popup handler */}
          <ExpiryProvider>     {/* ✅ Global expiry handler */}
            <AuthProvider>     {/* ✅ Legacy auth info/context (CRM-specific user fetching) */}
              <CallModeProvider>
              <LiveQueueProvider>
              <BrowserRouter>  {/* ✅ Router must wrap App + SoftphoneHost (useNavigate) */}
                <SoftphoneHost />
                <App />
              </BrowserRouter>
              </LiveQueueProvider>
              </CallModeProvider>
            </AuthProvider>
          </ExpiryProvider>
        </NotificationProvider>
      </ThemeProvider>
    </PlatformAuthProvider>
  </React.StrictMode>
);

reportWebVitals();
